// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageNav_bar__RJyc5 {
  position: sticky;
  top: 80px;
  z-index: 50;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--color-border);
  font-family: var(--font-sans);
}
.pageNav_inner__j2Gxb {
  max-width: calc(var(--container) + var(--gutter) * 2);
  margin: 0 auto;
  padding: 0 var(--gutter);
  display: flex;
  align-items: center;
  gap: var(--space-5);
}
.pageNav_list__II20V {
  flex: 1 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  gap: clamp(1rem, 2.5vw, 2.25rem);
  overflow-x: auto;
  scrollbar-width: none;
}
.pageNav_list__II20V::-webkit-scrollbar {
  display: none;
}
.pageNav_link__aG81r {
  position: relative;
  display: block;
  padding: 1.05rem 0;
  font-size: 0.925rem;
  font-weight: 500;
  color: var(--color-text-muted);
  text-decoration: none;
  white-space: nowrap;
  transition: color var(--dur-fast) ease;
}
.pageNav_link__aG81r::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 3px;
  background: var(--kur-gold);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform var(--dur) var(--ease-out);
}
.pageNav_link__aG81r:hover {
  color: var(--color-ink);
}
.pageNav_link__aG81r[aria-current="location"] {
  color: var(--color-ink);
  font-weight: 700;
}
.pageNav_link__aG81r[aria-current="location"]::after {
  transform: scaleX(1);
}
.pageNav_cta__YLY4T {
  display: none !important;
  min-height: 2.5rem !important;
  padding: 0.5rem 1.2rem !important;
  font-size: 0.875rem !important;
  flex: none;
}
@media (min-width: 900px) {
  .pageNav_cta__YLY4T {
    display: inline-flex !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/PAGE_NAV/pageNav.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,0BAA0B;EAC1B,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,qDAAqD;EACrD,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,gDAAgD;AAClD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE;IACE,+BAA+B;EACjC;AACF","sourcesContent":[".bar {\n  position: sticky;\n  top: 80px;\n  z-index: 50;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid var(--color-border);\n  font-family: var(--font-sans);\n}\n.inner {\n  max-width: calc(var(--container) + var(--gutter) * 2);\n  margin: 0 auto;\n  padding: 0 var(--gutter);\n  display: flex;\n  align-items: center;\n  gap: var(--space-5);\n}\n.list {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  gap: clamp(1rem, 2.5vw, 2.25rem);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.list::-webkit-scrollbar {\n  display: none;\n}\n.link {\n  position: relative;\n  display: block;\n  padding: 1.05rem 0;\n  font-size: 0.925rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  text-decoration: none;\n  white-space: nowrap;\n  transition: color var(--dur-fast) ease;\n}\n.link::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 3px;\n  background: var(--kur-gold);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform var(--dur) var(--ease-out);\n}\n.link:hover {\n  color: var(--color-ink);\n}\n.link[aria-current=\"location\"] {\n  color: var(--color-ink);\n  font-weight: 700;\n}\n.link[aria-current=\"location\"]::after {\n  transform: scaleX(1);\n}\n.cta {\n  display: none !important;\n  min-height: 2.5rem !important;\n  padding: 0.5rem 1.2rem !important;\n  font-size: 0.875rem !important;\n  flex: none;\n}\n@media (min-width: 900px) {\n  .cta {\n    display: inline-flex !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `pageNav_bar__RJyc5`,
	"inner": `pageNav_inner__j2Gxb`,
	"list": `pageNav_list__II20V`,
	"link": `pageNav_link__aG81r`,
	"cta": `pageNav_cta__YLY4T`
};
export default ___CSS_LOADER_EXPORT___;
